import { setThemeClass } from '@ifit/themes/setThemeClass';
import { ThemeContext } from '@ifit/themes/ThemeContext';
import cn from 'classnames';
import 'normalize.css';
import { useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import SnackbarError from './components/error';
import ErrorBoundary from './components/error-boundary';
import { showToast } from './util/show-toast';
import './sass/base.scss';
import { renderOnTest } from './util/renderOnTest';
import { trySetupWithQueryStringParams } from './util/try-setup-with-query-string-params';
import Dashboard from './components/dashboard';
import { I18nProvider, LocaleCode } from '@ifit/rapport-webview';
import i18n from './i18n';
import { WebviewError } from './types';

interface IProps {
  deviceType: string;
  webviewError: WebviewError;
  webviewErrorMsg: string;
  language: LocaleCode;
}

export function App({ deviceType, webviewError, webviewErrorMsg, language }: IProps): JSX.Element {
  const context = useContext(ThemeContext);
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    trySetupWithQueryStringParams();
    showToast(`base URL:\n "${window.location.origin}"\npath:\n "${window.location.pathname}"`, { autoClose: false });

    const userAgent = window.navigator.userAgent;
    if (userAgent.indexOf('Android 5') !== -1) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.add('no-animation');
    }

    setThemeClass(context);
  }, [theme, context]);

  return (
    <I18nProvider locale={language || 'en'} instance={i18n}>
      <div className={cn('app', deviceType)}>
        <ErrorBoundary>
          <Dashboard />
        </ErrorBoundary>
        {renderOnTest() && <SnackbarError message={webviewErrorMsg} error={webviewError} />}
      </div>
    </I18nProvider>
  );
}

export function mapStateToProps({ deviceType, webviewErrorMsg, webviewError, language }): IProps {
  return { deviceType, webviewErrorMsg, webviewError, language };
}

export default connect(mapStateToProps)(App);
